import React from 'react';
import { Box, Typography, Table, TableBody } from '@mui/material';

import { makeStyles } from 'tss-react/mui';

import { AnswerRow } from './AnsertRow';
import { useFormResponsesReviewData } from './FormResponsesReviewTable.hook';
import { MedicalNoteSubmittedBySimple } from '../MedicalNotes/MedicalNoteSubmittedBy.component';


const useStyles = makeStyles<Partial<FormResponsesReviewTableProps>>()(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(5),
  },

  group: {
    display: 'flex',
    flexDirection: 'column',
  },

  groupTitle: {
    color: theme.palette.secondary.main,
  },

  groupTable: {
    tableLayout: 'fixed',
  },
}));


export type FormResponsesReviewTableProps = {
  submissionId: string;
  patientId?: string;
  submittedAt?: string;
  classes?: Partial<typeof useStyles>;
};


export const FormResponsesReviewTable: React.VFC<FormResponsesReviewTableProps> = ({ submissionId, ...props }) => {
  const { classes } = useStyles(props, { props });
  const { groups } = useFormResponsesReviewData(submissionId);

  return (
    <Box className={classes.root}>
      {groups.map(group => (
        <Box key={group.title}>
          <Typography variant="overline" className={classes.groupTitle}>{group.title}</Typography>
          <Table className={classes.groupTable}>
            <TableBody>
              {group.items.map((item) => item ? (
                <AnswerRow key={item.id} title={item.title} value={item.value} type={item.type} />
              ) : null)}
            </TableBody>
          </Table>
        </Box>
      ))}

      {props.patientId && props.submittedAt && <MedicalNoteSubmittedBySimple submittedAt={props.submittedAt} userId={props.patientId} />}
    </Box>
  );
};
